import collegeApplicationRoadmapData from './college-application-roadmap-content.json';
import type { CollegeApplicationRoadmapContent } from './types';

export * from './types';

export const collegeApplicationRoadmapContent =
  collegeApplicationRoadmapData as CollegeApplicationRoadmapContent;
